import React from 'react';
import { motion } from 'framer-motion';
import { EASE_OUT } from '../utils/motion';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};

/**
 * Scroll reveal. Starts slightly BEFORE the element enters the viewport (positive bottom margin),
 * so by the time it's visible it is already settling instead of popping in under the reader's eyes.
 */
export function Reveal({
  children,
  className,
  delay = 0
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 8
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '0px 0px 12% 0px'
  }} transition={{
    duration: 0.3,
    ease: EASE_OUT,
    delay: Math.min(delay, 0.12)
  }} data-id="element-669" data-mp="2ns1snyhyk6qm">
      {children}
    </motion.div>;
}